import {Controller} from '@hotwired/stimulus'
import Choices from 'choices.js'
import configMerge from '../config-merge'
import {get, debounce} from 'lodash'

export default class extends Controller {
  static targets = ['choices']

  static values = {
    options: Object,
    queryUrl: String
  }

  queryTyped = debounce(async (e) => {
    if (e.detail.value === undefined || e.detail.value.length < 3)  {
      return this.choices.clearChoices()
    }

    const url = new URL(this.queryUrlValue)
    url.searchParams.append("q", e.detail.value)

    this.choices.setChoices(async () => {
      try {
        const items = await fetch(url.toString());
        return await items.json();
      } catch (err) {
        console.error(err);
      }}, "value", "label", true).then(() => {
          const input = this.element.querySelector("input[type=search]");
          if (input) {
            input.focus();
          }
        }
    )
  }, 500);

  initialize() {
    this.choices = new Choices(this.choicesTarget, this.options())
  }

  connect() {
    console.log('Stimulus Choices connected');
    this.choices.init();

    if (this.queryUrlValue) {
      this.element.addEventListener("search", (e) => {
        this.queryTyped(e);
      });
    }

    const value = this.choicesTarget.dataset?.selectedValue || this.choicesTarget?.value;
    if (value) {
      console.log(`Setting initial choice by value: ${value}`);
      this.choices.setChoiceByValue(value);
    }
  }


  disconnect() {
    this.choices.destroy()
  }

  options() {
    return configMerge([this.defaultOptions(), this.optionsValue])
  }

  defaultOptions() {
    return {
      searchEnabled: false,
      allowHTML: true,
      shouldSort: false,
      itemSelectText: ' ',
      classNames: {
        containerOuter: [...Array.from(this.choicesTarget.classList), "choices"],
      },
      callbackOnCreateTemplates: function () {
        return {
          choice: function (choicesConfig, choice, selectText) {
            choice.label = get(choice.element, 'dataset.htmlLabel', choice.label)

            return Choices.defaults.templates.choice.call(this, choicesConfig, choice, selectText)
          },
          item: function (choicesConfig, choice, removeItemButton) {
            choice.label = get(choice.element, 'dataset.htmlLabel', choice.label)

            return Choices.defaults.templates.item.call(this, choicesConfig, choice, removeItemButton)
          }
        }
      }
    }
  }
}
